import NetworkBehavior from "../lib/NetworkBehavior";
import { Time } from "../lib/Time";
import { Physics } from "../math/Physics";
import Vector2 from "../math/Vector2";
import Color from "../util/Color";
import Player from "./Player";

export default class DaggerMineBehavior extends NetworkBehavior {
    velocity = Vector2.zero;
    team: 'red'|'blue'|undefined;
    ownerName = "";
    damage = 1;
    lifetime = 10;
    born = Time.time;
    friction = 0.5;
    triggerRadius = 128;

    Die(playerHit?: Player) {
        if (this.isOwner && playerHit) {
            this.engine.sendDamagePacket(playerHit, this.damage);

            this.engine.createExplosionForAll({
                position: this.transform.position,
                size: this.triggerRadius,
                color: this.engine.clientPlayer?.team === this.team ? Color.fromHex('#55ff55') : Color.fromHex('#ff5555')
            });
        }

        
        this.engine.RemoveGameObject(this.gameObject);
    }

    Update(): void {
        if (Time.time - this.born >= this.lifetime) {
            this.Die();
            return;
        }

        this.velocity = this.velocity.sub(this.velocity.scale(this.friction * Time.deltaTime));
        this.transform.position = this.transform.position.add(this.velocity.scale(Time.deltaTime));
        this.transform.rotation = this.velocity.normalized;

        const validPlayers = this.engine.GetGameObjectsBehaviors<Player>(Player).filter(
            v => !v.isDead && v.team && v.team !== this.team
        );

        for (const player of validPlayers) {
            if (
                Physics.CircleCircleCollision({
                    position: this.transform.position,
                    radius: this.triggerRadius
                }, {
                    position: player.transform.position,
                    radius: player.size
                }) !== false
            ) {
                // this.engine.clientPlayer.Damage(this.damage);
                this.Die(player);
                return;
            }
        }

        
    }

    Draw(): void {
        this.ctx.lineWidth = 1;
        this.ctx.strokeStyle = this.engine.clientPlayer?.team === this.team ? '#55ff5522' : '#ff555522';
        this.engine.StrokeCircle(this.transform.position, this.triggerRadius);
        this.ctx.lineWidth = 2;
        this.ctx.strokeStyle = this.engine.clientPlayer?.team === this.team ? '#55ff55' : '#ff5555';
        this.engine.Line(this.transform.position.add(this.transform.forward.scale(4)), this.transform.position.add(this.transform.back.scale(4)));
        this.engine.Line(this.transform.position.add(this.transform.back.scale(4)).add(this.transform.left.scale(4)), this.transform.position.add(this.transform.back.scale(4)).add(this.transform.right.scale(4)));

        this.ctx.fillStyle = this.engine.clientPlayer?.team === this.team ? '#55ff5555' : '#ff555555';
        this.engine.FillRect(this.transform.position.add(new Vector2(-25, 8)), new Vector2(50, 4));
        this.ctx.fillStyle = this.engine.clientPlayer?.team === this.team ? '#55ff55' : '#ff5555';
        this.engine.FillRect(this.transform.position.add(new Vector2(-25, 8)), new Vector2(50 * (1 - (Time.time - this.born)/this.lifetime), 4));
    }
}